export const MCP_READ_SCOPE = "mcp:read";
export const MCP_WRITE_SCOPE = "mcp:write";
export const MCP_RESULTS_READ_SCOPE = "mcp:results:read";

// Anthropic/Claude appends offline_access to the authorization request only
// when the AS metadata advertises it, expecting a refresh token in return.
// Not a grantable McpScope: the authorize flow filters it out, and refresh
// tokens are issued on every exchange regardless.
export const MCP_OFFLINE_ACCESS_SCOPE = "offline_access";

export type McpScope =
  | typeof MCP_READ_SCOPE
  | typeof MCP_WRITE_SCOPE
  | typeof MCP_RESULTS_READ_SCOPE;

export const MCP_SUPPORTED_SCOPES: McpScope[] = [
  MCP_READ_SCOPE,
  MCP_WRITE_SCOPE,
  MCP_RESULTS_READ_SCOPE,
];
